import Swiper from 'swiper/bundle';

export default class {
   constructor() {
      var swiperMain = new Swiper(".swiper-main", {
         slidesPerView: 1,
         grabCursor: true,
         effect: "creative",
         speed: 800,
         creativeEffect: {
            prev: {
               shadow: true,
               translate: ["0", 0, -500],
            },
            next: {
               opacity: 0,
               translate: ["100%", 0, 0],
            },
         },
         loop: true,
         autoplay: {
            delay: 2000,
            disableOnInteraction: false,
         },
         pagination: {
           el: ".swiper-pagination",
           clickable: true,
         },
      });

      this.setCoordsPaginationActiveBullet();
      
      swiperMain.on('slideChange', () => {
         this.setCoordsPaginationActiveBullet();
      });

      swiperMain.on('resize', () => {
         this.setCoordsPaginationActiveBullet();
      });
   }

   setCoordsPaginationActiveBullet() {
      const activeSlide = document.querySelector('.swiper-main .swiper-pagination-bullet-active');
      const coord = activeSlide.offsetLeft;
      const paginationActive = activeSlide.parentElement.previousElementSibling;
      paginationActive.style.left = coord + 'px';
   }
}